<template>
  <div class="extend_time__form">
    <!-- สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.) -->
    <div class="custom_card mt-4">
      <v-layout justify-space-between pa-3>
        <v-flex shrink class="pr-4">
          <v-img
            :src="
              require('../../../../assets/images/extension-time/logo-rsp.png')
            "
            width="100"
            height="100"
          ></v-img>
        </v-flex>
        <v-flex xs8>
          <h1>สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.)</h1>
          <div class="font-12 font-w-400 mt-2">
            <Iconify
              class="mr-3"
              icon="ic:round-access-time"
              size="15px"
            ></Iconify>
            <span>
              วันที่เปิดรับโครงการ 31 พฤศจิกายน 2565 เวลา 00:00 น. - 30 ธันวาคม
              2565 เวลา 12:00 น.
            </span>
          </div>
          <div class="font-12 font-w-400 mt-2">
            <Iconify
              class="mr-3"
              icon="ic:round-access-time"
              size="15px"
            ></Iconify>
            <span>
              วันที่พิจารณาโครงการ 3 มกราคม 2566 เวลา 08:00 น. - 5 มกราคม 2566
              เวลา 12:00 น.
            </span>
          </div>
          <div class="font-12 font-w-400 pl-6 mt-2">
            โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์
            (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)
          </div>
        </v-flex>
        <v-spacer />
        <v-flex shrink>
          <div
            class="custom_card d-flex flex-column align-center justify-center"
            style="
              background-color: #f15a29;
              color: #fff;
              width: 100px;
              height: 100px;
              padding: 5px;
            "
          >
            <div class="font-20 font-w-600">ปี งปม.</div>
            <div class="font-32 font-w-600">2566</div>
            <div></div>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation class="mt-6">
      <div class="font-20 font-w-600 mb-4">แผนงาน</div>
      <div v-if="$route.params.id" class="font-16 font-w-600 mb-6">
        {{ form.plan_name }}
      </div>
      <v-select
        v-else
        :items="plans"
        item-text="plan_name_th"
        item-value="plan_name_th"
        v-model="form.plan_name"
        placeholder="โปรดระบุ"
        outlined
        color="#D3D3D3"
        background-color="#fff"
        dense
        menu-props="offsetY"
        return-object
        clearable
        style="border-radius: 30px"
        :class="form.plan_name ? 'active__value' : ''"
        :rules="[(v) => !!v || 'กรุณาระบุแผนงาน']"
        required
        @click:clear="form.projects = []"
        @change="onSelectPlan"
      ></v-select>

      <div class="font-20 font-w-600 mb-4">รายการโครงการย่อยที่ขอขยายเวลา</div>

      <table class="custom_table mb-4">
        <thead>
          <tr>
            <th width="5%">ลำดับ</th>
            <th width="45%">ชื่อโครงการ</th>
            <th width="10%">มหาวิทยาลัย</th>
            <th width="10%">ผู้นำเข้าข้อมูล</th>
            <th width="10%">ครั้งที่</th>
            <th width="10%">ระยะที่ขอขยาย</th>
            <th width="10%">ขยายถึง</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in form.projects" :key="i">
            <td>{{ i + 1 }}</td>
            <td>{{ item.project_name_th }}</td>
            <td>{{ item.university }}</td>
            <td>{{ item.user_name }}</td>
            <td>{{ item.project_no }}</td>
            <td>{{ item.duration }}</td>
            <td>{{ item.end_date }}</td>
          </tr>
        </tbody>
      </table>

      <div class="font-20 font-w-600 mb-4">รายการโครงการย่อยที่ขอขยายเวลา</div>

      <div class="custom_card">
        <v-layout class="mt-6">
          <v-flex xs12>
            <div class="font-14 font-w-600 mb-2">
              เหตุผล <span style="color: #f15a29">*</span>
            </div>
            <v-textarea
              v-model="form.reason"
              outlined
              dense
              rows="5"
              color="#D3D3D3"
              style="border-radius: 30px"
              placeholder="โปรดระบุ"
              :rules="[(v) => !!v || 'กรุณาระบุเหตุผล']"
              required
            ></v-textarea>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-space-between>
          <v-flex shrink class="font-14 font-w-700 mb-2">เอกสารเเนบ</v-flex>
          <v-flex shrink>
            <v-btn
              depressed
              dark
              rounded
              width="100"
              color="#F15A29"
              @click="addFile"
            >
              <v-icon class="font-12 font-w-700" left>mdi-plus</v-icon>
              <span class="font-12 font-w-700">เพิ่มไฟล์</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <div class="font-14" style="color: #f15a29">
          *ไฟล์ที่ระบบรองรับ .PDF/.doc (สูงสุด 10 MB/ไฟล์)
        </div>
        <v-layout
          class="mt-3 custom_file_input"
          v-for="(file, f) in form.files"
          :key="f"
        >
          <v-flex xs7>
            <v-file-input
              v-model="file.doc_file"
              :id="'file' + f"
              :rules="!file.doc_file ? rulesFile : []"
              color="#F15A29"
              style="border-radius: 30px"
              outlined
              height="36"
              placeholder=""
              prepend-icon=""
              accept="application/pdf, application/msword"
              v-show="
                checkValType(file.doc_file) == 'object' ||
                file.doc_file == '' ||
                file.doc_file == null
              "
            ></v-file-input>
            <v-text-field
              v-show="checkValType(file.doc_file) == 'string'"
              v-model="file.doc_file"
              outlined
              height="36"
              color="#F15A29"
              style="border-radius: 30px"
              readonly
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
              depressed
              dark
              rounded
              width="100"
              color="#464647"
              @click="uploadFile(f)"
            >
              <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
              <span class="font-12 font-w-700">อัพโหลด</span>
            </v-btn>
          </v-flex>
          <v-flex shrink ml-3>
            <v-btn
              depressed
              height="35"
              width="35"
              fab
              dark
              color="#FD0C0C"
              @click="removeFile(f)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>

      <v-layout class="mt-5">
        <v-flex shrink>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#D9D9D9"
            @click="$router.go(-1)"
          >
            <span class="font-14 font-w-700" style="color: #464647">
              ยกเลิก
            </span>
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink mr-4>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#FBB040"
            @click="onDraft()"
          >
            <span class="font-14 font-w-700">บันทึกฉบับร่าง</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- <pre>
      {{ form }}
    </pre> -->
  </div>
</template>

<script>
import DatePicker from "../../../../components/input/DatePicker.vue";
export default {
  components: { DatePicker },
  data() {
    return {
      valid: true,
      plans: [
        {
          plan_name_th:
            "แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)",
          plan_code: "1",
        },
        {
          plan_name_th: "แผนงานวิจัยร่วมกับภาคเอกชน  Collaborative Research",
          plan_code: "2",
        },
        {
          plan_name_th:
            "แผนงานบ่มเพาะธุรกิจวิทยาศาสตร์ เทคโนโลยีและนวัตกรรม STI Business Incubation",
          plan_code: "3",
        },
        {
          plan_name_th: "แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ Service Platform",
          plan_code: "4",
        },
      ],

      form: {
        plan_master_id: null,
        plan_name: "",
        plan_code: "",
        projects: [],
        reason: null,
        files: [],
      },
      rulesFile: [
        (value) =>
          !value ||
          value.size < 10000000 ||
          "File size should be less than 10 MB!",
        (value) => !!value || "กรุณาแนบเอกสาร",
      ],
    };
  },
  created() {
    console.log(this.$route.params.id);

    if (this.$route.params.id) {
      this.form = {
        plan_master_id: null,
        plan_name:
          "แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)",
        plan_code: "1",
        projects: [
          {
            id: 1,
            project_name_th: "โครงการพัฒนาสารกำจัดมด",
            university: "มหาวิทยาลัยสุรนารี",
            user_name: "user",
            project_no: "ครั้งที่ 1",
            duration: "6 เดือน",
            end_date: "10 ม.ค 2566",
          },
          {
            id: 2,
            project_name_th: "โครงการพัฒนาสารกำจัดมด",
            university: "มหาวิทยาลัยสุรนารี",
            user_name: "user",
            project_no: "ครั้งที่ 1",
            duration: "6 เดือน",
            end_date: "10 ม.ค 2566",
          },
        ],
        reason:
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Esse voluptatem recusandae libero dicta labore delectus voluptas, eos eum eaque illo, molestias in iste ducimus fuga, consequatur nesciunt ipsam fugiat dignissimos?",
        files: [
          {
            doc_file: "file.pdf",
          },
          {
            doc_file: "file.pdf",
          },
        ],
      };
    }
  },
  methods: {
    onSelectPlan(event) {
      console.log(event);
      this.form.plan_master_id = event.id;
      this.form.plan_name = event.plan_name_th;
      this.form.plan_code = event.plan_code;

      this.form.projects = [
        {
          id: 1,
          project_name_th: "โครงการพัฒนาสารกำจัดมด",
          university: "มหาวิทยาลัยสุรนารี",
          user_name: "user",
          project_no: "ครั้งที่ 1",
          duration: "6 เดือน",
          end_date: "10 ม.ค 2566",
        },
        {
          id: 2,
          project_name_th: "โครงการพัฒนาสารกำจัดมด",
          university: "มหาวิทยาลัยสุรนารี",
          user_name: "user",
          project_no: "ครั้งที่ 1",
          duration: "6 เดือน",
          end_date: "10 ม.ค 2566",
        },
      ];
    },

    addFile() {
      this.form.files.push({
        doc_file: null,
      });
    },
    removeFile(id) {
      this.form.files.splice(id, 1);
    },
    uploadFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },
    onDraft() {
      if (this.$refs.form.validate()) {
        this.form.status = "Draft";
        console.log("draft", this.form);
        this.$router.push("/rsp/extend-time");
      }
    },
  },
};
</script>

<style lang="scss">
.extend_time__form {
  .custom_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 15px 25px;
  }

  .custom_table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 20px;
    thead {
      // background-color: #f2f2f2;
      color: #b1b1b1;
      th {
        padding: 12px;
        border-bottom: 1px solid #ddd;
        text-align: left;
      }
    }
    tbody {
      tr {
        &:nth-child(even) {
          // background-color: #f2f2f2;
        }
        td {
          padding: 12px;
        }
      }
    }
  }

  .custom_file_input {
    .v-text-field--full-width .v-input__prepend-outer,
    .v-text-field--full-width .v-input__prepend-inner,
    .v-text-field--full-width .v-input__append-inner,
    .v-text-field--full-width .v-input__append-outer,
    .v-text-field--enclosed .v-input__prepend-outer,
    .v-text-field--enclosed .v-input__prepend-inner,
    .v-text-field--enclosed .v-input__append-inner,
    .v-text-field--enclosed .v-input__append-outer {
      margin-top: 4px !important;
    }
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: inherit !important;
  }
  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  .v-input__icon--clear {
    background: #d9d9d9;
    color: #fff !important;
  }

  .btn-save {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    padding: 0px 10px;
  }
  input {
    font-size: 16px !important;
  }
}
</style>
